// extracted by mini-css-extract-plugin
module.exports = {"mainTitleStyle":"style_mainTitleStyle__WlyHe"};